<template>
  <div class="ew-login-layout">
    <div class="container no-padding">
      <div class="row align-items-center">
        <!-- FORMULARIO -->
        <div class="col-lg-6 col-md-8 mx-auto">
          <div class="ew-login-form p-5 shadow rounded bg-white">
            <div class="text-center mb-4">
              <router-link to="/">
                <img class="ew-login-logo mb-3" src="@/assets/images/sack/logo.png" alt="Logo SackEnvios" />
              </router-link>
              <h2 class="mb-1">Restablecer contraseña</h2>
              <p class="text-muted">
                Ingresa tu nueva contraseña para completar el proceso.
              </p>
            </div>

            <!-- Alerta de éxito -->
            <b-alert :show="dismissCountDown" dismissible variant="success" @dismissed="dismissCountDown = 0"
              @dismiss-count-down="countDownChanged" class="mb-4">
              ✅ Tu contraseña se ha actualizado con éxito. Serás redirigido al inicio de sesión
              en {{ dismissCountDown }} segundos.
            </b-alert>

            <form @submit.prevent="changePassword" novalidate>
              <!-- Nueva contraseña -->
              <div class="mb-3">
                <label>
                  Nueva Contraseña <sup>*</sup>
                </label>
                <input type="password" class="form-control" v-model="password" required @input="$v.password.$touch()"
                  :class="{ 'is-invalid': $v.password.$error }" placeholder="Ingresa tu nueva contraseña" />
                <div class="invalid-feedback">
                  La contraseña debe tener entre {{ $v.password.$params.minLength.min }} y
                  {{ $v.password.$params.maxLength.max }} caracteres.
                </div>
              </div>

              <!-- Confirmar contraseña -->
              <div class="mb-4">
                <label>
                  Confirmar Nueva Contraseña <sup>*</sup>
                </label>
                <input type="password" class="form-control" v-model="passwordConfirm" required
                  @input="$v.passwordConfirm.$touch()" :class="{ 'is-invalid': $v.passwordConfirm.$error }"
                  placeholder="Repite tu nueva contraseña" />
                <div class="invalid-feedback">Las contraseñas no coinciden.</div>
              </div>

              <div class="text-center">
                <button type="submit" class="btn btn-lg btn-primary px-5" :disabled="$v.$invalid">
                  Cambiar contraseña
                </button>
              </div>
            </form>
          </div>
        </div>

        <!-- Imagen lateral -->
        <div class="col d-none d-lg-block ew-login-pattern"></div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.ew-login-layout {
  background: #f5f7fa;
  min-height: 100vh;
  display: flex;
  align-items: center;
}

.ew-login-form {
  background: #fff;
  border-radius: 16px;
  max-width: 700px;
}

.ew-login-logo {
  max-width: 180px;
}

label {
  font-weight: 600;
  color: #333;
}

sup {
  color: #e63946;
}

.form-control {
  border-radius: 8px;
  padding: 0.75rem;
  font-size: 1rem;
}

.form-control:focus {
  border-color: #007bff;
  box-shadow: 0 0 0 0.15rem rgba(0, 123, 255, 0.25);
}

.is-invalid {
  border-color: #dc3545 !important;
}

.invalid-feedback {
  font-size: 0.9rem;
  margin-top: 0.3rem;
}

.ew-login-pattern {
  min-height: 100vh;
  border-top-left-radius: 24px;
  border-bottom-left-radius: 24px;
}

@media (max-width: 768px) {
  .ew-login-form {
    padding: 2rem;
  }
}
</style>



<script>
import axios from 'axios'
import commons from '../commons'
import {
  required,
  minLength,
  maxLength,
  email,
  url,
  sameAs
} from 'vuelidate/lib/validators'
export default {
  name: 'ChangePassword',
  data() {
    return {
      password: '',
      passwordConfirm: '',
      dismissSecs: 5,
      dismissCountDown: 0
    }
  },
  methods: {
    changePassword() {
      axios.post(`${commons.apiURL}/api/v1/password-recovery/${this.$route.params.token}`, {
        password: this.password
      }).then(response => {
        console.log(response)
        console.log("jesus")
        if (response.data) {
          this.showAlert();
        }
      }).catch(error => {
        console.error(error)
      })
    },

    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
      if (this.dismissCountDown === 0) {
        this.$router.push('/signin')
      }

    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs
    }
  },
  validations: {
    password: {
      required,
      minLength: minLength(4),
      maxLength: maxLength(12)
    },
    passwordConfirm: {
      sameAsPassword: sameAs('password')
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/ChangePassword.vue